// extracted by mini-css-extract-plugin
export default {"topics":"_4RWMs","link":"DjSm2","restTopics":"bz-Qs"};